import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { LabelService } from '../../../services/label.service';
import { Business } from '../../../models/doctor-model';

@Component({
  selector: 'app-confirmation-panel-for-business',
  standalone: true,
  imports: [],
  templateUrl: './confirmation-panel-for-business.component.html',
  styleUrl: './confirmation-panel-for-business.component.scss',
})
export class ConfirmationPanelForBusinessComponent implements OnInit {
  @Input() businessData!: Business;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  businessDataLabelAndValue: { label: string; value: string }[] = [];
  isMissingVatOrFiscal: boolean = false;

  constructor(public labelService: LabelService) {}

  ngOnInit(): void {
    const { vat_number, fiscal_code } = this.businessData;
    this.isMissingVatOrFiscal = !vat_number || !fiscal_code;

    if (!this.isMissingVatOrFiscal) {
      this.businessDataLabelAndValue = Object.entries(this.businessData).map(
        ([key, value]) => ({
          label: key,
          value: value,
        })
      );
    } else {
      this.businessDataLabelAndValue = [];
    }
  }

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
}
